import { RefObject, useLayoutEffect, useRef, useState } from 'react';

const BOTTOM_MARGIN_PX = 48;

export function useFillViewportHeight<T extends HTMLElement>(
  enabled: boolean,
  minHeightPx: number,
): [RefObject<T | null>, number | undefined] {
  const ref = useRef<T>(null);
  const [maxHeight, setMaxHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      const top = el.getBoundingClientRect().top;
      const next = Math.max(minHeightPx, window.innerHeight - top - BOTTOM_MARGIN_PX);
      setMaxHeight((prev) => (prev !== undefined && Math.abs(prev - next) < 1 ? prev : next));
    };

    measure();
    window.addEventListener('resize', measure);
    const observer = new ResizeObserver(measure);
    observer.observe(document.body);
    return () => {
      window.removeEventListener('resize', measure);
      observer.disconnect();
    };
  }, [enabled, minHeightPx]);

  return [ref, maxHeight];
}
